import * as linksAPI from '../api/links'
import { useQuery } from 'react-query';

export default function useGetLabels() {
  const connectionToken = useQuery('connectionToken')
  return useQuery(['myLabels', connectionToken.data], linksAPI.getLabels)
}